var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      ref: "anchorSpan",
      class: _vm.anchorClass,
      attrs: { href: _vm.anchor },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.openFile.apply(null, arguments)
        },
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }